// 1. Termék mentése a localStorage-ba (Ezt a termékoldalon kell futtatni)
if (window.location.pathname.includes('/products/')) {
  const productHandle = window.location.pathname.split('/').pop();
  let viewedProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
  
  if (!viewedProducts.includes(productHandle)) {
    viewedProducts.unshift(productHandle);
    // Csak az utolsó 10-et tartjuk meg
    viewedProducts = viewedProducts.slice(0, 10);
    localStorage.setItem('recentlyViewed', JSON.stringify(viewedProducts));
  }
}

const recentContainer = document.querySelector('[id^="recently-viewed-products-"]');

if (recentContainer) {
  const viewedProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
  const limit = 4;
  let displayedCount = 0;

  async function renderRecentlyViewed() {
    recentContainer.innerHTML = '';
    
    for (const handle of viewedProducts) {
      if (displayedCount >= limit) break;

      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) continue;
        const product = await response.json();

        if (product.tags.includes('active')) {
          const cardHTML = createProductCardHTML(product);
          recentContainer.insertAdjacentHTML('beforeend', cardHTML);
          displayedCount++;
        }
      } catch (error) {
        console.error("Hiba a termék betöltésekor:", error);
      }
    }
  }

  // Segédfüggvény a HTML struktúra felépítéséhez a product-item.liquid alapján
  function createProductCardHTML(product) {
    const price = (product.price / 100).toLocaleString('hu-HU') + ' Ft';
    const comparePrice = (product.compare_at_price && product.compare_at_price > product.price) 
      ? (product.compare_at_price / 100).toLocaleString('hu-HU') + ' Ft' 
      : '';
    
    // Kedvezmény számítása (ha van compare_at_price)
    let discountBadge = '';
    if (product.compare_at_price > product.price) {
      const percentage = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
      discountBadge = `<div style="display: inline-block; padding: 2px 5px; background-color: #e22120; color: #fff; margin-bottom: 6px;">
                        <strong>-${percentage}%</strong>
                      </div>`;
    }

    return `
      <div class="product-item card" data-js-product-item>
        <a href="${product.url}" class="card__image product-item__image" style="padding-top: 100%">
        <figure class="lazy-image product-item__image-figure product-item__image-figure--primary lazy-image--animation lazy-image--background lazyloaded" data-ratio="1.0" style="padding-top: 100.0%" data-crop="false">

          <img src="${product.featured_image}" alt="${product.title}" class="product-item__image-figure img">
          </figure>
        </a>
        <div class="card__text product-item__text gutter--regular spacing--xlarge text-align--center">
          ${discountBadge}
          <a class="product-item__title" href="${product.url}">
            <div class="remove-line-height-space--small">
              <span class="text-weight--bold">${product.title}</span>
            </div>
          </a>
          <div class="product-item__price text-size--large">
            <div class="remove-line-height-space">
            ${comparePrice ? `<span class="compare-price" style="text-decoration: line-through; opacity: 0.6; margin-left: 5px;">${comparePrice}</span>` : ''}  
            <span class="price">${price}</span>
              
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderRecentlyViewed();
}